import type { Personalization } from '../types/personalization';

const MOCK_DELAY_MS = 250;

const wait = (ms: number) => new Promise<void>((resolve) => setTimeout(resolve, ms));

export async function fetchPersonalization(
  trackingId: string,
  signal?: AbortSignal,
): Promise<Personalization> {
  await wait(MOCK_DELAY_MS);
  if (signal?.aborted) {
    throw new DOMException('Aborted', 'AbortError');
  }

  return {
    trackingId,
    guardianName: '홍길동',
    petName: '초코',
    notificationKind: 'vaccination',
    message: '광견병 백신 접종 시기에 도달했어요.',
    ctaLabel: '우리엔에서 바로 보기',
  };
}

export async function reportLanding(
  trackingId: string | null,
  signal?: AbortSignal,
): Promise<void> {
  await wait(MOCK_DELAY_MS / 2);
  if (signal?.aborted) {
    return;
  }

  console.info('[mock-api] landing reported', { trackingId });
}
